import { destinations } from "@/data/resort";
import { Eyebrow, MaskReveal, Reveal } from "../reveal";

const storyIds = ["highway-49", "marshall-gold", "empire-mine"];

export function GoldCountryStory() {
  const cards = storyIds.map((id) => destinations.find((d) => d.id === id)).filter(Boolean);

  return (
    <section
      id="gold-country"
      aria-labelledby="gold-country-heading"
      className="bg-secondary/60 py-16 md:py-20"
    >
      <div className="shell">
        <Reveal>
          <Eyebrow>Follow the Gold</Eyebrow>
        </Reveal>
        <h2 id="gold-country-heading" className="display-lg mt-6 max-w-[18ch]">
          <MaskReveal>Explore the Story That</MaskReveal>
          <MaskReveal delay={0.08}>Changed California</MaskReveal>
        </h2>
        <Reveal delay={0.1}>
          <p className="mt-8 max-w-2xl text-base leading-relaxed text-muted-foreground">
            Auburn&apos;s location in California Gold Country places guests near historic
            communities, preserved mining sites and destinations associated with the events that
            shaped the region.
          </p>
        </Reveal>

        <ul className="mt-10 grid gap-6 md:grid-cols-3">
          {cards.map((card, i) =>
            card ? (
              <li key={card.id}>
                <Reveal delay={i * 0.07} className="h-full">
                  <article className="group h-full overflow-hidden border border-border bg-background">
                    <img
                      src={card.image}
                      alt={card.alt}
                      width={1000}
                      height={1200}
                      loading="lazy"
                      decoding="async"
                      className="aspect-[4/5] w-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
                    />
                    <div className="p-7">
                      <h3 className="font-display text-2xl tracking-tight">{card.name}</h3>
                      <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
                        {card.description}
                      </p>
                    </div>
                  </article>
                </Reveal>
              </li>
            ) : null,
          )}
        </ul>

        <Reveal delay={0.1}>
          <a
            href="#destination-explorer"
            className="eyebrow mt-8 inline-flex text-primary"
            onClick={(e) => {
              e.preventDefault();
              document
                .getElementById("destination-explorer")
                ?.scrollIntoView({ behavior: "smooth" });
              window.dispatchEvent(
                new CustomEvent("nearby-filter", { detail: { category: "Gold Country" } }),
              );
            }}
          >
            Explore Gold Country
          </a>
        </Reveal>
      </div>
    </section>
  );
}
